import { Row, Col, Button, Modal } from "react-bootstrap";
import { sensorJson } from "../../../Common/sensorData";
import _ from "lodash";
import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { attachSensorById } from "../../../api";
import { RESPONSE_ATTACHED_SENSOR_CODE, RESPONSE_INVALID_SENSOR_CODE, RESPONSE_LOCATION_BLOCKED_CODE } from "../../../Common/constants";
import { checkForAPISuccess, responseToastHandler } from "../../../Common/commonFunctions";
import { useDispatch } from "react-redux";
import { ADD_NEW_SENSOR, SET_ONGOING_EDIT_GLOBALLY } from "../../../store/actions";
import { ClipLoader } from "react-spinners";

const AttachSensor = props => {

    const [utils, setUtils] = useState({
        axial: '', vertical: '', sensorId: '', location: '',
        displayValidation: false, showPopup: false,
        attachedSensorMessage: '', locationOccupiedMsg : ""
    });

    const dispatch = useDispatch();
    const LOCATION = 'Location', AXIAL = 'Axial', VERTICAl = 'Vertical', ID = 'Sensor ID';
    const installLocations = _.uniq(
        _.concat(
            sensorJson.CONNECTOR.install_locations.values,
            sensorJson.DRIVER.install_locations.values,
            sensorJson.DRIVEN.install_locations.values
        )
    );
    const axialAndVertical = ["X", "Y", "Z"];
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

    const attachSensor = async () => {
        const payload = {
            "sensorId": utils?.sensorId,
            "componentId": props?.componentId,
            "sensorMetadata": { "install_info" : { "axial" : utils?.axial, "vertical" : utils?.vertical } },
            "installLocation": utils?.location
        };
        const response = await attachSensorById(payload);
        return response?.data;
    }

    const attachSensorQuery = useQuery(`attachSensor-${utils.sensorId}`, attachSensor, { ...useQueryConfiguration });

    useEffect(() => {
        if(attachSensorQuery.isFetched) {

            const data = attachSensorQuery?.data;
            if(attachSensorQuery.isSuccess && (
                checkForAPISuccess(data?.statusCode) ||
                _.isEqual(data?.statusCode, RESPONSE_ATTACHED_SENSOR_CODE) ||
                _.isEqual(data?.statusCode, RESPONSE_INVALID_SENSOR_CODE) ||
                _.isEqual(data?.statusCode,RESPONSE_LOCATION_BLOCKED_CODE)
            ))
            {
                if(data?.statusCode === RESPONSE_ATTACHED_SENSOR_CODE) {
                    setUtils({ ...utils, attachedSensorMessage: data?.statusMessage });
                }
                else if(data?.statusCode === RESPONSE_INVALID_SENSOR_CODE) {
                    responseToastHandler(data?.statusCode, { message: "Please provide a valid ID for sensor", callBack: () => {} }, null, null);
                }
                else if(data?.statusCode === RESPONSE_LOCATION_BLOCKED_CODE){
                    responseToastHandler(data?.statusCode,{message:`${data.statusMessage}`,callBack:() =>{}},null,null);
                }
                else {
                    dispatch({
                        type: ADD_NEW_SENSOR,
                        payload: {
                            id: utils.sensorId,
                            metadata: { axial: utils.axial, vertical: utils.vertical },
                            location: utils.location,
                            bearingInformation: data?.data?.bearingInformation
                       }
                    });
                    props.hideSensorAttachFields();

                    const onSuccess = { message: "Sensor attached successfully", callBack: () => {} };
                    responseToastHandler(data?.statusCode, null, onSuccess, null);
                }
            }
            else {
                props.hideSensorAttachFields();
                const onFailure = { message: "Failed to attach sensor", callBack: () => {} };
                responseToastHandler(data?.statusCode, onFailure, null, onFailure);
            }
            attachSensorQuery.remove();
        }
    }, [attachSensorQuery.isFetched]);

    const handleFields = (field, value) => {

        if(_.isEqual(field, LOCATION)) {
            setUtils({ ...utils, location: value });
        }
        else if(_.isEqual(field, AXIAL)) {
            setUtils({ ...utils, axial: value });
        }
        else if(_.isEqual(field, VERTICAl)) {
            setUtils({ ...utils, vertical: value });
        }
        else {
            value = value.replaceAll("-", "").toUpperCase();
            value.length <= 8 && /^[0-9A-Fa-f]*$/.test(value) && setUtils({ ...utils, sensorId: returnHyphenatedSensorId(value) });
        }
    }

    const returnHyphenatedSensorId = (sensorId) => {
        let sensorIdArr = [];
        for(var i = 0; i < sensorId.length; i += 2) {
            sensorIdArr.push(sensorId.substr(i, 2));
        }
        return sensorIdArr.join('-');
    }

    const padZerosAtFrontToSensorId = () => {
        if(checkIfSensorIdIsValid() && utils.sensorId.replaceAll("-", "").length < 8) {
            let paddedSensorId = utils.sensorId.replaceAll("-", "").padStart(8, "0");
            setUtils({ ...utils, sensorId: returnHyphenatedSensorId(paddedSensorId) });
        }
        else {
            document.getElementById(ID).focus();
        }
    }

    const checkIfSensorIdIsValid = () => utils.sensorId.replaceAll("0", "").replaceAll("-", "").length > 0

    const disableAttach = () => 
        _.isEmpty(utils.sensorId) || _.isEmpty(utils.location) || _.isEmpty(utils.vertical) || _.isEmpty(utils.axial);

    const returnSensorAttachFields = (label) =>
        <Row style={{"border": "none", "borderBottom": "1px solid #eaeaea"}} className="mx-0 my-2">
            <Col className="py-0 px-2 text-left" sm={5} xs={5} md={5} lg={5} xl={5}>
                {label}
            </Col>
            <Col className="py-0 text-left" sm={7} xs={7} md={7} lg={7} xl={7}>
                {
                    _.isEqual(label, ID) ?
                        <>
                            <input id={ID} onChange={(event) => handleFields(label, event.target.value)}
                                className="profile-input-class text-center w-100" onBlur={() => padZerosAtFrontToSensorId()}
                                value={utils.sensorId} placeholder="Enter ID 8 characters or less"
                            />
                            {
                                utils.displayValidation &&
                                    <div className="font-weight-bold color-red">
                                        {
                                            _.isEmpty(utils.sensorId)
                                        }
                                    </div>
                            }
                        </>
                            :
                        <>
                            <select
                                value={utils[label.toLowerCase()]}
                                disabled={!checkIfSensorIdIsValid()}
                                className="text-left w-100" 
                                style={{"border": "none", "borderBottom": "1px solid #075978"}}
                                onChange={(event) => handleFields(label, event.target.value)}
                            >
                                <option value="" selected disabled hidden>Choose {label}</option>
                                {
                                    _.isEqual(label, LOCATION) ?
                                        installLocations.map((location) => <option>{location}</option>)
                                            :
                                        axialAndVertical.map((value) => <option>{value}</option>)
                                }
                            </select>
                            { utils.displayValidation && _.isEmpty(utils[label.toLowerCase()]) && <div className="font-weight-bold color-red">Select any value</div> }
                        </>
                }
            </Col>
        </Row>

    const terminateSensorAttach = () => {
        dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: false });
        props.hideSensorAttachFields();
    }

    return (
        <>
            {
                attachSensorQuery.isFetching ?
                    <div className="text-center my-5">
                        <ClipLoader color="#075978" />
                    </div>
                        :
                    <>
                        { returnSensorAttachFields(ID) }
                        { returnSensorAttachFields(AXIAL) }
                        { returnSensorAttachFields(VERTICAl) }
                        { returnSensorAttachFields(LOCATION) }
                        <div className="float-right">
                            <Button onClick={() => props.hideSensorAttachFields()} style={{"border": "none", "backgroundColor": "gray"}}>Cancel</Button>
                            <Button onClick={() => {attachSensorQuery.refetch()}} disabled={!checkIfSensorIdIsValid() || disableAttach()}>Attach</Button>
                        </div>
                    </>
            }
            
            <Modal show={!_.isEmpty(utils.attachedSensorMessage)} onHide={() => terminateSensorAttach()} backdrop="static">

                <Modal.Header closeButton>
                    <h4 className="font-weight-bold">Attached Sensor</h4>
                </Modal.Header>

                <Modal.Body>
                    <div className="my-5 font-weight-bold">
                        {utils.attachedSensorMessage}
                        <br />
                        Please detach it before attaching it here.
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => terminateSensorAttach()}>Ok</Button>
                </Modal.Footer>

            </Modal>
        </>
    )

}

export default AttachSensor;